import React from 'react';
import { Modal, Button, Typography, Space } from 'antd';

const { Text, Link } = Typography;

const TermsAndConditionsModal = ({ visible, onAccept, onDecline }) => {
  return (
    <Modal
      title="Terms and Conditions"
      open={visible}
      footer={null}
      closable={false}
      maskClosable={false}
      width={600}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Text>
          Before proceeding, please review and accept our Terms and Conditions.
        </Text>
        
        <Text>
          By clicking "Accept", you confirm that you have read and agree to the 
          <Link href="https://www.rightnowresponse.com/terms-conditions" target="_blank" style={{ marginLeft: 5 }}>
            Terms and Conditions
          </Link>.
        </Text>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button type="default" onClick={onDecline}>
            Decline
          </Button>
          <Button type="primary" onClick={onAccept}>
            Accept
          </Button>
        </div>
      </Space>
    </Modal>
  );
};

export default TermsAndConditionsModal;
